import * as React from "react";
import { forwardRef } from "react";
const SvgIconPie = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 25, fill: "none", viewBox: "0 0 100 100", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 50, cy: 50, r: 40, stroke: "#fff", strokeWidth: 5 }), /* @__PURE__ */ React.createElement("path", { stroke: "#fff", strokeWidth: 5, d: "M50 10a40 40 0 0 1 40 40H50Z" }));
const ForwardRef = forwardRef(SvgIconPie);
export { ForwardRef as ReactComponent };
